<template>
  <div class="card shadow-sm h-100">
    <div class="card-header bg-body-tertiary py-2 d-flex align-items-center justify-content-between">
      <h6 class="mb-0">
        <i class="bi bi-list-check me-2"></i>Checklist de Seeds
      </h6>
      <span class="badge bg-body-secondary text-body border border-secondary-subtle">
        {{ progresso.concluidos }} / {{ progresso.total }}
      </span>
    </div>

    <div class="card-body p-3">
      <div class="mb-3">
        <div class="d-flex justify-content-between small text-body-secondary mb-1">
          <span>Progresso</span>
          <span>{{ progresso.percentual }}%</span>
        </div>
        <div
          class="progress"
          role="progressbar"
          :aria-valuenow="progresso.percentual"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div
            class="progress-bar"
            :class="progresso.percentual === 100 ? 'bg-success' : 'bg-primary'"
            :style="{ width: progresso.percentual + '%' }"
          ></div>
        </div>
      </div>

      <div v-if="carregando" class="text-center text-body-secondary py-4">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Carregando status dos seeds...
      </div>

      <div v-else-if="seeds.length === 0" class="text-center text-body-secondary py-4">
        <i class="bi bi-inbox fs-3 d-block mb-2"></i>
        Nenhum seed neste grupo.
      </div>

      <template v-else>
        <SeedItem
          v-for="seed in seeds"
          :key="seed.chave"
          :seed="seed"
          :status="statusDe(seed)"
          :desabilitado="estaDesabilitado(seed)"
          :motivo="motivoBloqueio(seed)"
          :config="configuracoesSeeds[seed.chave] || {}"
          @acao="aoAgir"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import SeedItem from './SeedItem.vue'
import { ESCOPO_TENANT, ESCOPO_ORGANIZACAO, obterSeed } from '@/constants/seedsCatalog'

const props = defineProps({
  seeds: { type: Array, default: () => [] },
  statusSeeds: { type: Object, default: () => ({}) },
  progresso: { type: Object, default: () => ({ total: 0, concluidos: 0, percentual: 0 }) },
  empresaAtiva: { type: [Number, String], default: null },
  organizacaoAtiva: { type: [Number, String], default: null },
  carregando: { type: Boolean, default: false },
  configuracoesSeeds: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['acao'])

function statusDe (seed) {
  return props.statusSeeds[seed.chave] || 'nao_rastreado'
}

function estaDesabilitado (seed) {
  if (props.statusSeeds[seed.chave] === 'executando') return true
  // Seeds de organização exigem empresa + organização (o escopo é dentro do banco do tenant).
  if (seed.escopo === ESCOPO_ORGANIZACAO) {
    if (!props.empresaAtiva || !props.organizacaoAtiva) return true
  } else if (seed.escopo === ESCOPO_TENANT && !props.empresaAtiva) {
    return true
  }
  if (seed.preRequisito && props.statusSeeds[seed.preRequisito] !== 'concluido') return true
  return false
}

function motivoBloqueio (seed) {
  if (props.statusSeeds[seed.chave] === 'executando') return 'Executando...'
  if (seed.escopo === ESCOPO_ORGANIZACAO) {
    if (!props.empresaAtiva) return 'Selecione uma empresa no topo'
    if (!props.organizacaoAtiva) return 'Selecione uma organização no topo'
  } else if (seed.escopo === ESCOPO_TENANT && !props.empresaAtiva) {
    return 'Selecione uma empresa no topo'
  }
  if (seed.preRequisito && props.statusSeeds[seed.preRequisito] !== 'concluido') {
    const pre = props.seeds.find(s => s.chave === seed.preRequisito) || obterSeed(seed.preRequisito)
    return `Pré-requisito pendente: ${pre?.nome || seed.preRequisito}`
  }
  return ''
}

function aoAgir (payload) {
  emit('acao', payload)
}
</script>

<style scoped>
.progress {
  height: 0.6rem;
}
</style>
